// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export default function Theme() {
  const flatUi = {
    turquoise: '#1ABC9C',
    greenSea: '#16A085',
    emerald: '#2ECC71',
    nephritis: '#27AE60',
    peterRiver: '#3498DB',
    belizeHole: '#2980B9',
    amethyst: '#9B59B6',
    wisteria: '#8E44AD',
    wetAsphalt: '#34495E',
    midnightBlue: '#2C3E50',
    sunFlower: '#F1C40F',
    orange: '#F39C12',
    carrot: '#E67E22',
    pumpkin: '#D35400',
    alizarin: '#E74C3C',
    pomegranate: '#C0392B',
    clouds: '#ECF0F1',
    silver: '#BDC3C7',
    concrete: '#95A5A6',
    asbestos: '#7F8C8D'
  };

  const greyColors = {
    0: '#FFFFFF',
    50: '#F8FAFB',
    100: flatUi.clouds,
    200: '#D9E1E4',
    300: flatUi.silver,
    400: '#AAB7B8',
    500: flatUi.concrete,
    600: flatUi.asbestos,
    700: '#5D6D7E',
    800: flatUi.wetAsphalt,
    900: flatUi.midnightBlue,
    A50: '#F4F7F7',
    A100: '#E5EAEC',
    A200: '#CAD2D3',
    A400: '#99A3A4',
    A700: '#566573',
    A800: '#273746'
  };

  return {
    primary: {
      lighter: '#D6EAF8',
      100: '#AED6F1',
      200: '#85C1E9',
      light: '#5DADE2',
      400: '#3498DB',
      main: flatUi.peterRiver,
      dark: '#2E86C1',
      700: flatUi.belizeHole,
      darker: '#1F618D',
      900: '#154360',
      contrastText: '#FFFFFF'
    },
    secondary: {
      lighter: '#EBDEF0',
      100: '#D7BDE2',
      200: '#C39BD3',
      light: '#AF7AC5',
      400: flatUi.amethyst,
      main: flatUi.amethyst,
      600: '#884EA0',
      dark: flatUi.wisteria,
      800: '#6C3483',
      darker: '#512E5F',
      A100: '#F5EEF8',
      A200: '#E8DAEF',
      A300: '#D2B4DE',
      contrastText: '#FFFFFF'
    },
    error: {
      lighter: '#FADBD8',
      light: '#F1948A',
      main: flatUi.alizarin,
      dark: flatUi.pomegranate,
      darker: '#922B21',
      contrastText: '#FFFFFF'
    },
    warning: {
      lighter: '#FCF3CF',
      light: '#F8C471',
      main: flatUi.sunFlower,
      dark: flatUi.orange,
      darker: flatUi.pumpkin,
      contrastText: flatUi.midnightBlue
    },
    info: {
      lighter: '#D1F2EB',
      light: '#76D7C4',
      main: flatUi.turquoise,
      dark: flatUi.greenSea,
      darker: '#0E6251',
      contrastText: '#FFFFFF'
    },
    success: {
      lighter: '#D5F5E3',
      light: '#82E0AA',
      main: flatUi.emerald,
      dark: flatUi.nephritis,
      darker: '#1E8449',
      contrastText: '#FFFFFF'
    },
    grey: greyColors
  };
}
